import { render, staticRenderFns } from "./RetailerInsights.vue?vue&type=template&id=feb2d620&"
import script from "./RetailerInsights.vue?vue&type=script&lang=js&"
export * from "./RetailerInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports